import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * useScrollToTop - 페이지 이동 시 스크롤을 맨 위로 초기화하는 커스텀 훅
 * @returns {void}
 */
function useScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // 경로가 변경될 때마다 스크롤 맨 위로 이동
        window.scrollTo(0, 0);
    }, [pathname]); // 의존성 배열에 pathname 추가
}

export default useScrollToTop;
